/// <amd-module name="Dashboards/Directory/redux/DashboardsDirectoryModule" />
import { AnyAction, combineReducers, ReducersMapObject } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { IDashboardsDirectoryAwareState, IDashboardsDirectoryState } from "../DashboardsDirectoryContracts";
import { artifactReducer } from "./DashboardsDirectoryArtifactReducer";
import { dashboardsDirectorySaga } from "./DashboardsDirectorySaga";
import { favoritesSaga } from "./FavoritesSaga";

export function getDashboardDirectoryModule(): ISagaModule<IDashboardsDirectoryAwareState> {
    const reducerMap: ReducersMapObject<IDashboardsDirectoryAwareState, AnyAction> = {
        dashboardsDirectoryState: combineReducers<IDashboardsDirectoryState>({
            directoryArtifactState: artifactReducer
        })
    };

    return {
        id: "dashboards-directory",
        reducerMap,
        sagas: [dashboardsDirectorySaga, favoritesSaga]
    };
}
